import React from 'react';

import { images } from '@/constants/images';

import { NextImageWrapper } from '../NextImageWrapper/NextImageWrapper';

type PlusUpLogoProps = {
	height?: number | string
	width?:  number | string
};

// TODO use recipe to create different size
export const PlusUpLogo = ({ height, width = '200px' }: PlusUpLogoProps) => {
	return (
		<NextImageWrapper
			aspectRatio="ultrawide"
			height={height}
			image={images.logo.plusUpRecruit}
			objectFit="contain"
			sizes={width ? `${width}` : '200px'}
			width={width}
		/>
	);
};
